
export enum ECustomFormatter {
    NoFrills
}
